const ENV = process.env.REACT_APP_ENV || 'development';

const config = {
  local_demo: {
    mockData: true,
    s3BaseUrl: 'https://d21jto2ryclhi.cloudfront.net',
    verifyProApiUrl: null,
    authApiUrl: 'https://nx6nn1st64.execute-api.us-east-2.amazonaws.com/api',
  },
  development: {
    s3BaseUrl: 'https://d21jto2ryclhi.cloudfront.net',
    verifyProApiUrl: 'http://127.0.0.1:8000',
    authApiUrl: 'https://nx6nn1st64.execute-api.us-east-2.amazonaws.com/api', //'http://127.0.0.1:9000',
    mockData: false,
  },
  staging: {
    s3BaseUrl: 'https://d21jto2ryclhi.cloudfront.net',
    verifyProApiUrl: 'https://qdoi6eigmh.execute-api.us-east-2.amazonaws.com/api',
    authApiUrl: 'https://nx6nn1st64.execute-api.us-east-2.amazonaws.com/api',
    mockData: false,
  },
  production: {
    s3BaseUrl: 'https://d21jto2ryclhi.cloudfront.net',
    verifyProApiUrl: 'http://127.0.0.1:8000',
    authApiUrl: 'https://nx6nn1st64.execute-api.us-east-2.amazonaws.com/api',
    mockData: false,
  },
  local: {
    s3BaseUrl: 'https://d21jto2ryclhi.cloudfront.net',
    verifyProApiUrl: 'http://127.0.0.1:8000',
    authApiUrl: 'http://127.0.0.1:8000',
    mockData: false,
  }
};

const config_strings = {
  intros: {
    dashboard: {
      title: 'Welcome to the ViV Client Desktop',
      text: 'This app is the central hub to perform various operations on Provenance, Verifications, Consumers, Marketing, NFT, and Integrations. Through these modules, administrators can manage product provenance data, monitor verifications, and manage NFTs.',
    },
    provisioning: {
      title: 'Tag Provisioning',
      text: 'Tag Provisioning in the VerifyPro displays pre-configured RFID tag selections for each platform setup. This section shows authorized tag types tailored to specific product authentication needs. The overview provides crucial context for managing Provenance records and product verification data. Actual tag inventory and association are handled externally to the VerifyPro.',
    },
    provenance: {
      title: 'Product Provenance',
      text: "Product Provenance creation allows producers to add detailed product information, building complete records for authentication. Producers can organize products by batches, releases, or series for easy tracking. This creates detailed profiles of each product's origin and characteristics, linking them to their unique tags for verification",
    },
    verification: {
      title: 'Verification Logs',
      text: "Monitor and analyze product verification attempts.",
    },
    nfts: {
      title: 'NFT Collections',
      text: 'The NFT section provides visibility into your wine collections on the blockchain. Browse and manage ERC721 token collections representing your wine batches, and view individual bottle tokens',
    },
    consumer_details: {
      title: 'Consumer Details',
      text: 'Individual user data',
    },
    marketing: {
      title: 'Marketing',
      text: 'Create, manage, and export marketing campaigns.',
    },
    integrations: {
      title: 'Verification Tag Snippet',
      text: 'This section provides the JavaScript code snippet for the Product Verification tag. Copy and paste this code into your website to display the verification result. The snippet creates a dynamic HTML element that shows the authentication status of your product.',
    },
  },
  
  legal: {
    company_info: {
      name: 'ViV Wine and Spirits Limited',
      company_number: '15213546',
      registered_address: 'Africa House, 70 Kingsway, London, Greater London, United Kingdom, WC2B 6AH',
      incorporated_date: '16 October 2023',
      contact_email: 'info@vivwineandspirits.com',
      website: 'vivwineandspirits.com'
    },
    
    privacy_policy: {
      title: 'Privacy Policy',
      last_updated: 'January 2025',
      sections: {
        about: {
          title: '1. About This Policy',
          content: 'ViV Wine and Spirits Limited ("we", "us", "our") operates the ViV Client Desktop application for wine and spirits provenance management. This policy explains how we collect, use, and protect your personal data when you use our platform.'
        },
        data_collection: {
          title: '2. Data We Collect',
          content: '<strong>Account Data:</strong> Name, email address, login credentials<br /><strong>Product Data:</strong> Provenance records, verification logs, product information<br /><strong>Usage Data:</strong> System logs, access times, feature usage<br /><strong>Technical Data:</strong> IP address, browser type, device information'
        },
        data_usage: {
          title: '3. How We Use Your Data',
          content: '• Provide provenance tracking and verification services<br />• Monitor system security and prevent fraud<br />• Improve our platform and develop new features<br />• Comply with legal obligations and regulatory requirements'
        },
        data_sharing: {
          title: '4. Data Sharing',
          content: 'We do not sell your personal data. We may share data with trusted service providers for platform operations, with regulatory authorities when required by law, and with your consent for specific business purposes.'
        },
        user_rights: {
          title: '5. Your Rights (GDPR)',
          content: 'You have the right to access, correct, delete, or restrict processing of your personal data. You may also object to processing or request data portability. To exercise these rights, contact us at info@vivwineandspirits.com.'
        },
        data_security: {
          title: '6. Data Security',
          content: 'We implement industry-standard security measures including encryption, access controls, and regular security audits to protect your data against unauthorized access, alteration, or destruction.'
        },
        data_retention: {
          title: '7. Data Retention',
          content: 'We retain personal data only as long as necessary for the purposes outlined in this policy or as required by law. Provenance data may be retained longer for regulatory compliance.'
        },
        cookies: {
          title: '8. Cookies',
          content: 'We use essential cookies for platform functionality and analytics cookies to improve our services. You can manage cookie preferences through your browser settings or our cookie settings panel.'
        },
        contact: {
          title: '9. Contact Us',
          content: 'For privacy-related questions or to exercise your data rights:<br /><strong>Email:</strong> info@vivwineandspirits.com<br /><strong>Website:</strong> <a href="https://vivwineandspirits.com" target="_blank">vivwineandspirits.com</a>'
        }
      }
    },
    
    terms_of_service: {
      title: 'Terms of Service',
      last_updated: 'January 2025',
      sections: {
        agreement: {
          title: '1. Agreement',
          content: 'By accessing the ViV Wine and Spirits Client Desktop application, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not access the service.'
        },
        service_description: {
          title: '2. Service Description',
          content: 'Our platform provides wine and spirits provenance management, including product tracking, verification services, consumer data management, marketing tools, NFT management, and third-party integrations for authorized users.'
        },
        user_responsibilities: {
          title: '3. User Responsibilities',
          content: '• Provide accurate and complete information<br />• Maintain the security of your account credentials<br />• Use the platform only for lawful purposes<br />• Comply with all applicable laws and regulations<br />• Respect intellectual property rights'
        },
        prohibited_activities: {
          title: '4. Prohibited Activities',
          content: 'You may not: attempt to gain unauthorized access to the system, interfere with platform operations, upload malicious content, violate any laws, or use the service for fraudulent activities or misrepresentation of products.'
        },
        data_privacy: {
          title: '5. Data and Privacy',
          content: 'Your use of the platform is subject to our Privacy Policy. You are responsible for ensuring you have appropriate rights to upload and process any data through our platform.'
        },
        intellectual_property: {
          title: '6. Intellectual Property',
          content: 'The platform and its content are owned by ViV Wine and Spirits Limited. You retain ownership of your data but grant us necessary rights to provide the service. All trademarks remain property of their respective owners.'
        },
        service_availability: {
          title: '7. Service Availability',
          content: 'We strive for high availability but cannot guarantee uninterrupted service. We may temporarily suspend service for maintenance, updates, or due to circumstances beyond our control.'
        },
        limitation_liability: {
          title: '8. Limitation of Liability',
          content: 'To the fullest extent permitted by law, ViV Wine and Spirits Limited shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the platform.'
        },
        termination: {
          title: '9. Termination',
          content: 'We may terminate or suspend your access immediately for any breach of these Terms. Upon termination, your right to use the service ceases immediately.'
        },
        changes_terms: {
          title: '10. Changes to Terms',
          content: 'We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Continued use of the service constitutes acceptance of modified terms.'
        },
        governing_law: {
          title: '11. Governing Law',
          content: 'These Terms are governed by the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.'
        },
        contact: {
          title: '12. Contact Information',
          content: 'For questions about these Terms of Service:<br /><strong>Email:</strong> info@vivwineandspirits.com<br /><strong>Website:</strong> <a href="https://vivwineandspirits.com" target="_blank">vivwineandspirits.com</a>'
        }
      }
    },
    
    cookie_settings: {
      title: 'Cookie Settings',
      description: 'We use cookies to enhance your experience and analyze platform usage. You can manage your cookie preferences below.',
      categories: {
        essential: {
          title: 'Essential Cookies',
          description: 'Required for basic platform functionality including authentication and security.',
          required: true
        },
        analytics: {
          title: 'Analytics Cookies',
          description: 'Help us understand how you use the platform to improve our services.',
          required: false
        },
        marketing: {
          title: 'Marketing Cookies',
          description: 'Used to deliver relevant content and track campaign effectiveness.',
          required: false
        }
      }
    }
  }
}

export default config[ENV];
export { config_strings };
